(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sectionSelector = 'main [id^="shopify-section-template"]';
  const skipSectionSelector = [
    '[data-vs-before-after]',
    '[data-vs-count-up]',
    '[data-vs-motion-marquee]',
    '.vs-before-after',
    '.vs-count-up',
    '.vs-motion-marquee'
  ].join(',');

  const revealGroups = [
    {
      selector: '.blog-preview_header-content, .homepage-shop-by-need__header, .homepage-product-paths__header',
      kind: 'soft'
    },
    {
      selector: 'h1, h2, .heading-style-h1, .heading-style-h2',
      kind: 'soft'
    },
    {
      selector: '.text-size-large, .text-size-medium, .button-hero-cta',
      kind: 'soft'
    },
    {
      selector: '.home-article_wrapper, .article-preview_wrapper, .need-card, .path-card, .feature-benefit-card, .build-slide, .trust-elements_card',
      kind: 'card'
    },
    {
      selector: '.article-preview_image, .path-card img, .feature-benefit-card img',
      kind: 'image'
    }
  ];

  const isVisibleCandidate = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const markElement = (element, kind, index) => {
    if (!element || element.dataset.vsReveal || element.closest(skipSectionSelector)) return false;
    if (!isVisibleCandidate(element)) return false;
    element.dataset.vsReveal = kind;
    element.style.setProperty('--vs-reveal-delay', `${Math.min(index * 70, 280)}ms`);
    return true;
  };

  const collectRevealItems = () => {
    const items = [];
    document.querySelectorAll(sectionSelector).forEach((section) => {
      if (section.querySelector(skipSectionSelector)) return;
      let sectionIndex = 0;

      revealGroups.forEach((group) => {
        section.querySelectorAll(group.selector).forEach((element) => {
          if (markElement(element, group.kind, sectionIndex)) {
            items.push(element);
            sectionIndex += 1;
          }
        });
      });
    });
    return items;
  };

  const revealNow = (items) => {
    items.forEach((element) => element.classList.add('is-vs-visible'));
  };

  const init = () => {
    const items = collectRevealItems();
    root.dataset.vsMotionReady = 'true';

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealNow(items);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-vs-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12
    });

    items.forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.9) {
        element.classList.add('is-vs-visible');
        return;
      }
      observer.observe(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    root.removeAttribute('data-vs-motion-ready');
    window.requestAnimationFrame(init);
  });
})();
